<template>
    <div ref="bellIconRef"
         class="notification">
        <span class="notification__number">{{ NOTIFICATION_COUNT }}</span>
        <i class="notification__bell fa-solid fa-bell" />
    </div>
</template>

<script setup lang="ts">
    import { ref, h } from 'vue';
    import useTippyPopup from '../../../../composables/useTippyPopup';
    import NotificationTippyContent from './NotificationTippyContent.vue';
    import { asset_cdn } from '@/js/helpers/helpers';
    import { useBellNotificationDataStore } from '@/js/store/notifications/NotificationBellStore';

    const store = useBellNotificationDataStore();

    const NOTIFICATION_COUNT = 3;

    const bellIconRef = ref(null);

    useTippyPopup(bellIconRef, {
        content: () => h(NotificationTippyContent, {
            notifications:
                store.bellNotificationData?.data.map((item) => ({
                    ...item,
                    image_path: asset_cdn(item.image_path, 55),
                })) ?? [],
            loading: store.loading,
        }),
        theme: 'base',
        trigger: 'click',
        interactive: true,
        placement: 'bottom',
        onShow: () => {
            if (!store.bellNotificationData) {
                store.getBellNotificationData();
            }
        },
    });
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/design-system/variables" as variables;

.notification {
    position: relative;
    width: 16px;
    margin-top: 4px;
    cursor: pointer;

    &__bell {
        color: legacyVariables.$titan-white;
        font-size: 19px;
        transition: color 200ms ease;

        &:hover {
            color: legacyVariables.$white;
        }
    }

    &__number {
        position: absolute;
        top: -7px;
        right: -7px;
        display: flex;
        width: 14px;
        height: 14px;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        background-color: variables.$error500;
        color: variables.$baseWhite;
        font-size: 10px;
        font-weight: 600;

        &::after {
            position: absolute;
            width: 20px;
            height: 20px;
            border-radius: 8px;
            margin: auto;
            animation: pulsing 1.7s linear infinite;
            background-color: variables.$error500;
            content: "";
            inset: 0 0 0 -3px;
            pointer-events: none;
            transform: scale(0.4);
            transform-origin: center center;
        }
    }
}

@keyframes pulsing {
    0% {
        opacity: 0;
        transform: scale(0.3);
    }

    50% {
        opacity: 0.3;
    }

    70% {
        opacity: 0.09;
    }

    100% {
        opacity: 0;
        transform: scale(3);
    }
}
</style>
